import { render, staticRenderFns } from "./account-layout.vue?vue&type=template&id=6df56497&scoped=true"
import script from "./account-layout.vue?vue&type=script&lang=js"
export * from "./account-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df56497",
  null
  
)

export default component.exports